/**
 * Coworker icon — used wherever the AI-coworker concept needs a visual mark
 * (mention popover, message header, inbox catch-up, streaming DM bubble).
 *
 * experiment/solar-icons — replaces the original 3-path custom SVG with
 * Solar's Cloud icon (Linear weight) for visual consistency with the rest
 * of the migration. The export name stays `CoworkerIcon` so all 4 call
 * sites keep working without touching their imports.
 */
import { Cloud } from "@solar-icons/react";
import type { CSSProperties } from "react";

interface CoworkerIconProps {
  size?: number | string;
  className?: string;
  style?: CSSProperties;
  color?: string;
}

function CoworkerIcon({
  size = 24,
  className,
  style,
  color,
}: CoworkerIconProps) {
  return (
    <Cloud
      size={size}
      weight="Linear"
      className={className}
      style={style}
      color={color}
    />
  );
}

export { CoworkerIcon };
